<template>
  <div>
    <b-form-checkbox
      switch
      v-model="showProductHints"
      class="gid-checkbox-right d-block mb-1 text-right"
    >
      <small class="text-muted">{{ $t('inputs.products.show-hints') }}</small>
    </b-form-checkbox>
    <div class="gid-striped">
      <product
        v-for="(product, index) in selectedProducts"
        :key="product.elementIndex"
        class="gid-striped-item pt-2 px-2 mx-n2"
        :allowDuplicateServices="allowDuplicateServices"
        :edit-products="editProducts"
        :elementIndex="product.elementIndex"
        :jobId="jobId"
        :readonly="readonly"
        :hide-price-listing="hidePriceListing"
        :hide-price-purchasing="hidePricePurchasing"
        :hide-price-selling="hidePriceSelling"
        :types-exclude="typesExclude"
        :types-include="typesInclude"
        :editPriceListing="editPriceListing"
        :editPriceSelling="editPriceSelling"
        :editPricePurchasing="editPricePurchasing"
        :editInvoicingTarget="editInvoicingTarget"
        :context="context"
        :orderDetails="orderDetails"
        :allowSelection="allowSelection"
        :selections="jobProducts[index]?.selections || []"
        :show-product-hints="showProductHints"
        :hint="product.hint"
      />
    </div>
    <div class="my-3 d-flex align-items-baseline">
      <div v-if="editProducts && !readonly">
        <b-button
          v-e2e:addProduct
          size="sm"
          variant="outline-primary"
          class="mr-2"
          @click="addProduct"
        >
          {{ $t('inputs.products.add') }}
        </b-button>
        <b-button
          v-e2e:resetProducts
          size="sm"
          variant="outline-secondary"
          @click="resetProducts"
        >
          {{ $t('reset') }}
        </b-button>
      </div>
    </div>
    <template v-if="showTotals">
      <div class="text-right">
        <strong>Revenue:</strong>
        <span class="mr-1">{{ revenue | currency }}</span>
        <strong>Cost:</strong>
        <span class="mr-1">{{ costs | currency }}</span>
      </div>
      <div class="text-right">
        <strong>Gross Margin:</strong>
        <span class="mr-1">{{ (revenue - costs) | currency }}</span>
      </div>
    </template>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

import BaseInput from './mixins/BaseInput';
import Product from './Product';

import {
  PRODUCTS_SELECTED_ADD,
  PRODUCTS_SELECTED_UNSET,
} from '../../store/products.module/types';

export default {
  mixins: [BaseInput],
  components: {
    Product,
  },
  props: {
    jobProducts: {
      type: Array,
      default: () => [],
    },
    allowDuplicateServices: {
      type: Boolean,
      default: false,
    },
    products_endpoint: String,
    currentPricePurchasing: Number,
    currentPriceSelling: Number,
    hidePricePurchasing: Boolean,
    hidePriceSelling: Boolean,
    hidePriceListing: Boolean,
    editProducts: {
      type: Boolean,
      default: true,
    },
    editPriceSelling: Boolean,
    editPricePurchasing: Boolean,
    editInvoicingTarget: Boolean,
    editPriceListing: Boolean,
    jobId: {
      type: String,
      default: 'new',
    },
    readonly: Boolean,
    typesExclude: Array,
    typesInclude: Array,
    context: String,
    revenue: Number,
    costs: Number,
    showTotals: Boolean,
    orderDetails: Array,
    allowSelection: {
      type: Boolean,
      default: false,
    },
    selections: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      oldProducts: [],
      newPricePurchasing: 0,
      priceChanged: false,
      showProductHints: false,
    };
  },
  computed: {
    selectedProducts() {
      return this.$store.getters
        .selectedProducts(this.jobId)
        .map((product, index) => ({
          ...product,
          elementIndex: index,
        }))
        .filter(({ group_id }) => !group_id || group_id == this._uid);
    },
    ...mapGetters(['locale']),
  },
  methods: {
    addProduct() {
      this.$store.commit(PRODUCTS_SELECTED_ADD, {
        jobId: this.jobId,
        product: null,
        quantity: 1,
        services: [],
        value_entry: 1,
        group_id: this._uid,
      });
    },
    resetProducts() {
      this.$store.dispatch(PRODUCTS_SELECTED_UNSET, { jobId: this.jobId });
    },
  },
};
</script>

<style>
.gid-products-list {
  background: red;
}
</style>
